import * as Sentry from "@sentry/react";
import { datadogRum } from "@datadog/browser-rum";

let env;
if (window.location.hostname == "localhost") {
    env = "local";
}
if (window.location.hostname == "ntime-dev.sentinelfertigation.com") {
    env = "testing";
}
if (window.location.hostname == "ntime.sentinelfertigation.com") {
    env = "production";
}

if (["production", "testing"].includes(env)) {
    Sentry.init({
        dsn: "https://388e88af4d1cfc9cbef3f3ba51897d3b@o4507823397732352.ingest.us.sentry.io/4509227179638784",
        sendDefaultPii: true,
        environment: env,
        integrations: [],
    });
    datadogRum.init({
        applicationId: "9c5feb5e-eb25-4c89-925c-15e2465e0661",
        clientToken: "pubff60201e0198cccf4c6982b6f3a52a1d",
        site: "us3.datadoghq.com",
        service: "angular-n-time",
        env: env,
        version: "1.0.0",
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input",
    });
}
